module.exports = __webpack_public_path__ + "static/img/android.53bcf29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/android.png
// module id = LbF0
// module chunks = 0